import SmartAutocompleteBase from "../assets/SmartAutocompleteBase";
import SalePointsApi from "../api/references/salePoints";
import {RichCell} from "@vkontakte/vkui";
import React from "react";

class SalePointsMapAutocomplete extends SmartAutocompleteBase {

    getItems = (search_ = '', append = false, page = 1) => {
        const search = search_ ? search_ : this.state.search
        if (!search || search.length < 2) {
            this.setState({items: [], loading: false})
            return
        }

        this.setState({loading: true})

        SalePointsApi.autocomplete(search, this.state.numItems).then((response) => {
            this.setState({loading: false})
            const results = response.data.items || response.data.results || []
            const items = results.map(el => ({
                ...el,
                name: el.title || el.name,
                uid: el.id,
                descr: el.full_address || el.address || ''
            }))

            this.setState({
                items,
                cnt_items: items.length,
                totalPages: 1
            })
            setTimeout(() => this.checkShowList(), 300)
        }).catch(() => {
            this.setState({loading: false, items: []})
        })
    }

    renderRow(el, index) {
        const typeLabel = el.isMall == 1 ? 'ТЦ' : 'Торговая точка'
        return (
            <RichCell
                key={'map_autocomplete_' + index}
                multiline
                onClick={() => this.selectObject(index)}
                subhead={el.descr}
                caption={typeLabel}
            >
                {el.name}
            </RichCell>
        )
    }
}

export default SalePointsMapAutocomplete

